<div class="dialog">
  <div class="dialog-background" (click)="continue()"></div>
  <div class="dialog-content">
    <h2>{{ 'survey.exit.title' | translate }}</h2>
    <p>{{ 'survey.exit.p' | translate }}</p>
    <div class="ui-button-group reverse">
      <button (click)="exit()" class="ui-button secondary">{{ 'survey.exit.exit' | translate }}</button>
      <button (click)="continue()" class="ui-button">{{ 'survey.exit.cta' | translate }}</button>
    </div>
  </div>
</div>
